import { render, staticRenderFns } from "./BigMapDiff.vue?vue&type=template&id=089bdf24&scoped=true"
import script from "./BigMapDiff.vue?vue&type=script&lang=js"
export * from "./BigMapDiff.vue?vue&type=script&lang=js"
import style0 from "./BigMapDiff.vue?vue&type=style&index=0&id=089bdf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089bdf24",
  null
  
)

export default component.exports